exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.hidden[data-v-e497ec34] {\n    display: none;\n}\n.preview[data-v-e497ec34] {\n    width: 80px;\n    height: 30px;\n    border: 1px dashed gray;\n    text-align: center;\n}\n\n", ""]);

